import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { ExpandWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  getColumnReferencesFromString,
  getNamedInputReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('Expand')
export class ExpandNode extends BaseWorkflowNode<ExpandWorkflowNode> {
  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return getColumnReferencesFromString(this.node.column, schemas);
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return getTagReferencesFromString(this.node.column, schemas);
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return getParamReferencesFromString(this.node.column, schemas, connectors);
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return getNamedInputReferencesFromString(this.node.column, schemas);
  }
}
